import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import {
  PreApprovedData,
  PreApprovedPayload,
} from '../../modules/front-office/interface/pre-approved-interface';
import { handleError } from '../../utils/api-error-handling';
import { encryptPayload } from '../../utils/security';

export const preApprovedApi = createApi({
  reducerPath: 'preApprovedApi',
  baseQuery: baseQuery,
  tagTypes: ['Pre-Approved'],
  endpoints: (builder) => ({
    getPreApproved: builder.query({
      query: (query) => {
        return `pre-approved${query}`;
      },
      providesTags: ['Pre-Approved'],
      transformErrorResponse: async (baseQueryReturnValue) => {
        return handleError(baseQueryReturnValue);
      },
      transformResponse: async (response: PreApprovedData) => {
        return response;
      },
      forceRefetch() {
        return true;
      },
    }),
    postPreApproved: builder.mutation({
      query: (payload: PreApprovedPayload) => ({
        url: 'pre-approved',
        method: 'POST',
        body: encryptPayload(payload),
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          dispatch(preApprovedApi.util.invalidateTags(['Pre-Approved']));
        }
      },
      transformErrorResponse: async (baseQueryReturnValue) => {
        return handleError(baseQueryReturnValue);
      },
    }),
    deletePreApproved: builder.mutation({
      query: (payload) => ({
        url: `pre-approved/${payload}`,
        method: 'DELETE',
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        if (data) {
          dispatch(preApprovedApi.util.invalidateTags(['Pre-Approved']));
        }
      },
      transformErrorResponse: async (baseQueryReturnValue) => {
        return handleError(baseQueryReturnValue);
      },
    }),
  }),
});

export const {
  useLazyGetPreApprovedQuery,
  useGetPreApprovedQuery,
  usePostPreApprovedMutation,
  useDeletePreApprovedMutation,
} = preApprovedApi;
